import angular from 'angular';

MembershipCategoriesController.$inject = [
  '$scope',
  '$state',
  '$uibModal',
  '$timeout',
  'ApiService',
  'NoticeFactory',
  'PermissionsService',
  'HelpersService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'ConfigService',
];

function MembershipCategoriesController(
  $scope,
  $state,
  $uibModal,
  $timeout,
  ApiService,
  NoticeFactory,
  PermissionsService,
  HelpersService,
  GridStateFactory,
  GridDefinitionFactory,
  ConfigService
) {
  $scope.membershipCategories = {
    categories: [],

    searchQuery: '',
    isLoaded: false,

    viewId: '',
    userPreferencesLoaded: false,
    gridName: $state.current.name + '.grid0',

    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),

    columns: [
      {
        field: 'id',
        displayName: 'Id',
        visible: false,
      },
      {
        field: 'name',
        displayName: 'Name',
        visible: true,
      },
      {
        field: 'program',
        displayName: 'Program',
        visible: true,
      },
      {
        field: 'category',
        displayName: 'Level',
        visible: true,
      },
      {
        field: 'subcategory',
        displayName: 'Subcategory',
        visible: true,
      },
      {
        field: 'state',
        displayName: 'Status',
        cellTemplate:
          '<div class="ui-grid-cell-contents"><span data-ng-if="row.entity.state !== \'published\'">Draft</span><span data-ng-if="row.entity.state === \'published\'">Published</span></div>',
        visible: true,
      },
    ],

    optionsOverride: {
      enableRowSelection: false,
      multiSelect: true,
      noUnselect: false,
      data: 'membershipCategories.categories',
      appScopeProvider: {
        onDblClick: function (row) {
          $scope.membershipCategories.gridDoubleClick(row);
        },
        remove: function (id) {
          $scope.membershipCategories.remove(id);
        },
        onDataGridPaginate: function (newPageNumber, newPageSize) {
          $scope.membershipCategories.onDataGridPaginate(newPageNumber, newPageSize);
        },
        onDataGridColumnReordered: function (column, originalPosition, newPosition, columns) {
          $scope.membershipCategories.onDataGridColumnReordered(column, originalPosition, newPosition, columns);
        },
        onDataGridSortChange: function (grid, columns) {
          $scope.membershipCategories.onDataGridSortChange(grid, columns);
        },
        onDataGridColumnChanged: function (changedColumn, columns) {
          $scope.membershipCategories.onDataGridColumnChanged(changedColumn, columns);
        },
        onDataGridSelectionChange: function (row, e) {
          $scope.membershipCategories.onDataGridSelectionChange(row, e);
        },
      },
      columnDefs: [
        {
          field: 'id',
          displayName: 'Id',
          visible: false,
        },
        {
          field: 'level',
          displayName: 'Level',
          visible: false,
        },
        {
          field: 'program',
          displayName: 'Program',
          visible: true,
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'category',
          displayName: 'Category',
          visible: true,
        },
        {
          field: 'subcategory',
          displayName: 'Subcategory',
          visible: true,
        },
      ],
    },

    notice: new NoticeFactory(),

    init: function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Membership Levels',
        buttonRight: {
          permissions: 'MEMBERSHIP_CATEGORY_CREATE',
          label: 'New Level',
          action: function () {
            $scope.membershipCategories.create();
          },
        },
      });

      this.orderId = $state.params.orderId;
      this.viewId = $state.current.name;

      if (PermissionsService.check('MEMBERSHIP_CATEGORY_DELETE')) {
        this.columns.push({
          field: 'remove',
          displayName: 'Remove',
          width: 80,
          onCellNavClick: function (row, col) {
            $scope.membershipCategories.remove(row.entity.id);
          },
          cellTemplate:
            '<div class="ui-grid-cell-contents text-center"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
        });
      }

      if (PermissionsService.check('MEMBERSHIP_CATEGORY_UPDATE')) {
        this.columns.unshift({
          field: 'edit',
          displayName: 'Edit',
          width: 50,
          onCellNavClick: function (row, col) {
            $scope.membershipCategories.gridDoubleClick(row);
          },
          cellTemplate:
            '<div class="ui-grid-cell-contents text-center"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">Edit<span class="sr-only"> Details</span></a></div>',
        });
      }

      this.gridDefinition.init(this.gridName, this.optionsOverride);

      this.getUserPreferences();
      $scope.$on('ConfigService::SettingsLoaded', this.onUserPreferencesUpdated);
    },

    getCategories: function () {
      const props = this.gridState.getGridState();
      if (this.userPreferencesLoaded) {
        props.salesChannels = 'online';
        props.isPublished = '0';
        ApiService.membership.categories.list(props).then(this.success.getCategories, this.error.getCategories);
      }
    },

    create: function () {
      const self = $scope.membershipCategories;

      this.notice.hideErrorMessages();
      this.notice.hideSuccessMessages();

      $state.go('application.membership.categories.create.description');
    },

    findCategory: function (id) {
      const self = $scope.membershipCategories;
      let result: { category: any; index: number } | false = false;

      for (let i = 0, ii = self.categories.length; i < ii; i++) {
        if (self.categories[i].id === id) {
          result = {
            category: self.categories[i],
            index: i,
          };
          break;
        }
      }
      return result;
    },

    remove: function (id) {
      const self = $scope.membershipCategories;
      const current = self.findCategory(id);

      self.addModal = $uibModal.open({
        templateUrl: 'views/application/views/membership/categories/modals/removeCategory.tpl.html',
        size: 'md',
        controller: 'MembershipCategoriesRemoveModalController',
        resolve: {
          currentMembershipCategory: function () {
            return current.category;
          },
        },
      });

      // Invoked when modal completes with close(params)
      self.addModal.result.then(
        function (name) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          self.isRemoving = true;

          ApiService.membership.categories.remove(current.category).then(function (response) {
            self.categories.splice(current.index, 1);
            self.success.remove(response);
          }, self.error.remove);
        },
        function () {
          // Do nothing
        }
      );
    },

    search: function () {
      this.gridState.setPropertyValue('search', this.searchQuery);
      this.getCategories();
    },

    process: function (categories) {
      for (let i = 0, ii = categories.length; i < ii; i++) {
        categories[i].displayDescription = categories[i].shortDescription
          ? HelpersService.strip(categories[i].shortDescription, 80)
          : HelpersService.strip(categories[i].description, 80);
        if (categories[i].types instanceof Array && categories[i].types.length) {
          categories[i].program = categories[i].types[0].program;
          categories[i].category = categories[i].types[0].category;
          categories[i].subcategory = categories[i].types[0].subcategory;
        }
      }

      return categories;
    },

    gridDoubleClick: function (item) {
      if (PermissionsService.check('MEMBERSHIP_CATEGORY_UPDATE')) {
        $state.go('application.membership.categories.edit.description', { id: item.entity.id });
      }
    },

    getUserPreferences: function () {
      if ($scope.loadPreferences) {
        if (
          ConfigService.isPreferencesLoadedForKey(
            ConfigService.settingsTypes.view,
            this.viewId,
            this.gridDefinition.options.gridName
          )
        ) {
          this.userPreferences = ConfigService.getPreferencesByKey(
            ConfigService.settingsTypes.view,
            this.viewId,
            this.gridDefinition.options.gridName
          );
          if (this.userPreferences) {
            this.gridDefinition.setColumns(this.columns, this.userPreferences);
            $scope.membershipCategories.gridState.applyPreferences(
              angular.extend({}, this.userPreferences, { pageSizes: this.gridDefinition.options.paginationPageSizes })
            );
            this.gridDefinition.options.paginationPageSize = this.gridState.getPropertyValue('pageSize');
          } else {
            //set default state for this grid if needed
            this.gridState.updateGridState(null, this.gridDefinition.options.paginationPageSize, 'name', 'asc');
            this.gridDefinition.setColumns(this.columns, null);
          }
          this.userPreferencesLoaded = true;
        }
        //otherwise wait for the preferences loaded event to fire.
      } else {
        //set default state for this grid if no user preferences
        this.gridState.updateGridState(null, this.gridDefinition.options.paginationPageSize, 'name', 'asc');
        this.gridDefinition.setColumns(this.columns, null);
        this.userPreferencesLoaded = true;
      }

      if (this.userPreferencesLoaded) {
        if (!this.isLoaded) {
          this.getCategories();
        }
      }
    },

    updateUserPreferences: function () {
      let config;

      if ($scope.loadPreferences) {
        config = angular.extend(this.userPreferences || {}, {
          pageSize: this.gridState.getPropertyValue('pageSize'),
          sortField: this.gridState.getPropertyValue('sortField'),
          sortDirection: this.gridState.getPropertyValue('sortDirection'),
          columns: this.gridDefinition.getColumnConfig(),
          type: 'grid',
        });

        ConfigService.setPreferencesByKey({
          type: ConfigService.settingsTypes.view,
          name: this.viewId,
          configType: config.type,
          key: this.gridDefinition.options.gridName,
          value: config,
        });

        this.userPreferences = config;

        console.log('SettingUserPreference', this.userPreferences);
      }
    },

    success: {
      init: function (response) {},
      getCategories: function (response) {
        const self = $scope.membershipCategories;

        self.categories = self.process(response.data.payload.list);
        self.gridDefinition.options.totalItems = response.data.payload.pagination.count;
        self.gridDefinition.isLoaded = true;
        self.isLoaded = true;
        $timeout(function () {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: self.gridDefinition.options.gridName,
            datasetLength: self.categories.length,
          });
        }, 10);
      },

      remove: function (response) {
        const self = $scope.membershipCategories;
        self.search();
      },
    },

    error: {
      init: function (response) {},
      getCategories: function (response) {},
      remove: function (response) {},
    },

    onDataGridPaginate: function (newPage, pageSize) {
      const self = $scope.membershipCategories;
      self.gridState.updateGridState(newPage, pageSize);
      if (!self.userPreferences || self.userPreferences.pageSize != pageSize) {
        self.updateUserPreferences();
      }
      self.getCategories();
    },

    onDataGridSortChange: function (grid, columns) {
      const self = $scope.membershipCategories;
      const data = columns[0];

      if (data) {
        self.gridState.updateGridState(null, null, data.field, data.sort.direction);
        self.updateUserPreferences();
        self.getCategories();
      }
    },

    onDataGridColumnReordered: function (column, originalPosition, newPosition, columns) {
      const self = $scope.membershipCategories;
      self.gridDefinition.setColumnConfig(columns);
      self.updateUserPreferences();
    },

    onUserPreferencesUpdated: function (e, data) {
      //get user preferences
      const self = $scope.membershipCategories;
      if (data.name == self.viewId) {
        self.getUserPreferences();
      }
    },
  };

  $scope.membershipCategories.init();
}

export const MembershipCategoriesControllerModule = angular
  .module('acme.view.application.membership.categories.controllers', [
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.factory.notice',
    'acme.common.service.permissions',
    'acme.common.service.helpers',
    'acme.view.application.membership.categories.removeModal.controllers',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.service.config',
  ])
  .controller('MembershipCategoriesController', MembershipCategoriesController).name;
